'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * @file sessionStorage封装
 */

var sessionStorage = global.sessionStorage;

if (!sessionStorage) {

  sessionStorage = global.sessionStorage = {};
  global.sessionStorage_cache = {};

  sessionStorage.setItem = function (key, value) {
    global.sessionStorage_cache[key] = value;
  };

  sessionStorage.getItem = function (key) {
    return global.sessionStorage_cache[key];
  };

  sessionStorage.removeItem = function (key) {
    delete global.sessionStorage_cache[key];
  };
}

exports.default = {
  /**
   * 设置本地缓存
   * @param {string} name - 键名
   * @param {*} data - 键值
   */
  setItem: function setItem(name, data) {
    try {
      if (data instanceof String) {
        return sessionStorage.setItem(name, data);
      }
      sessionStorage.setItem(name, JSON.stringify(data));
    } catch (e) {
      throw new Error('存储失败');
    }
  },


  /**
   * 获取本地缓存
   * @param {string} name - 键名
   * @returns {*} 键值
   */
  getItem: function getItem(name) {
    try {
      // 默认返回json
      return JSON.parse(sessionStorage.getItem(name));
    } catch (err) {
      return sessionStorage.getItem(name);
    }

    return null;
  },


  /**
   * 删除本地缓存
   * @param {string} name - 键名
   */
  removeItem: function removeItem(name) {
    sessionStorage.removeItem(name);
  },


  /**
   * 删除所有本地缓存
   */
  clear: function clear() {
    sessionStorage.clear();
  }
};


//////////////////
// WEBPACK FOOTER
// ./src/utils/store/sessionStorage.js
// module id = 454
// module chunks = 14